/*** IMPORTS FROM imports-loader ***/
var $ = require("jquery");
var jQuery = require("jquery");

var toString = {}.toString;

module.exports = Array.isArray || function (arr) {
  return toString.call(arr) == '[object Array]';
};




/*****************
 ** WEBPACK FOOTER
 ** ./~/buffer/~/isarray/index.js
 ** module id = 1309
 ** module chunks = 0
 **/